<template>
  <div class="signup-importPhoto">
    <el-button type="primary" @click="ImportDialogVisible=true">{{btnName}}</el-button>
    <!-- 导入 -->
    <el-dialog title="国际证书上传" :close-on-click-modal="false" :visible.sync="ImportDialogVisible" width="60%" class="import-stu-info-dialog" :append-to-body="true" v-if="ImportDialogVisible">
        <div class="stu-zj-photos-con">
            <div class="upload-stu-photos-con">
                <h3 class="h3-title-val">
                    <span> 国际证书上传</span>
                </h3>
                <div class="clearfix step-upload-item">
                    <div class="clearfix">
<!-- 
                        <el-upload class="upload-demo fr" ref="upload" :action="uploadZipFilePro" :file-list="fileList" :auto-upload="false" :on-success="onSuccessUrl" accept="zip" :limit="1" style="display: inline-block; text-align: center;margin-top:15px;">
                            <el-button slot="trigger" type="primary">选择导入文件</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload> -->

                        <!-- <el-upload class="upload-demo fl" list-type="picture-card" :action="uploadZipFilePro" accept=".zip" v-loading="loading1" :on-success="onSuccessUrl" :on-error="onErrorUrl" :before-upload="startUpload1" :show-file-list="false" >
                            <div class="upload-text-con">
                                <p class="p-upload-icon"><i class="el-icon-upload"></i></p>
                                <p v-if="!fileName1">点击上传</p>
                                <p v-else>重新上传</p>
                            </div>
                        </el-upload> -->


                        <el-upload
                            class="upload-demo fl"
                            ref="upload"
                            :auto-upload="false" 
                            drag
                            :action="uploadZipFilePro"
                            :on-success="onSuccessUrl" 
                            :on-error="onErrorUrl"
                            :before-upload="startUpload1"
                            accept=".zip"
                            >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                         </el-upload>

                        <div class="p-upload-tip-con fl">

                            <p>发证日期:<el-date-picker
                                v-model="dateofIssue"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker></p>

                            <p>注意事项：</p>
                            <p style="font-weight: 600;">证书图片统一打包成zip压缩包上传 </p>
                            <p style="font-weight: 600;">证书图片统一格式: jpg/png </p>
                            <p style="font-weight: 600;">证书图片命名:  个人证书编号.jpg或个人证书编号.png</p>
                        </div>
                    </div>
                    <div class="p-file-name" v-if="fileName1">{{ fileName1 }} <i class="el-icon-circle-check"></i> </div>

                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="importFile">确定导入</el-button>
                    </span>
                </div>
            </div>
        </div>
    </el-dialog>


    <!-- 数据导入结果 -->
    <el-dialog title="数据导入结果" :visible.sync="dataResultVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="tip-info-main">
            <div class="import-table-con">
                <p>
                    <i class="kz-icon-tishi"></i> 您本次共导入{{count}}条数据，导入结果如下
                </p>
                <div>
                    <div class="clearfix down-load-btn">
                        <span class="fl sp-import-num">导入成功：{{successNum}}条</span>
                        <!-- <a v-if="successNum>0" :href="successUploadFileUrl">
                            <el-button type="primary" class="fr">下载导入成功记录</el-button>
                        </a> -->
                    </div>
                    <div class="clearfix down-load-btn">
                        <span class="fl sp-import-num">导入失败：{{failNum}}条</span>
                        <a v-if="failNum>0 && failExcel" :href="failExcel" target="_blank">
                            <el-button type="primary" class="fr download-model-btn">下载导入失败记录</el-button>
                        </a>
                    </div>
                    <p v-if="failNum>0" style="margin-top:8px;color:#909399;">失败数据未导入。下载的压缩包内含失败证书图片和《导入失败记录.xlsx》，可查看每条失败原因。</p>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dataResultVisible = false">取 消</el-button>
            <el-button type="primary" @click="dataResultVisible = false">关 闭</el-button>
        </span>
    </el-dialog>

    <!-- 进度条 -->
    <el-dialog title="数据导入中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
        <div class="tip-info-main">
            <div class="import-table-con">
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelImport">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    btnName:{
        type: String,
        default: "导入"
    },
    // examId:{
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {
        fileList: [], //导入文件
        ImportDialogVisible: false,
        loading1: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
        loading6: false,
        loading7: false,
        loading8: false,
        loading9: false,
        loading10: false,
        loading11: false,
        loading12: false,



        fileName1: "",
        fileName2: "",
        fileName3: "",
        fileName4: "",
        fileName5: "",
        fileName6: "",
        fileName7: "",
        fileName8: "",
        fileName9: "",
        fileName10: "",
        fileName11: "",
        fileName12: "",


        // 导入结果
        dataResultVisible: false,
        wordUrl: "",
        count: 0,
        failExcel:"",
        successNum: 0,
        successFileName: "",
        failNum: 0,
        failFileName: "",
        percentageVisible:false,
        percentage:0,
        taskId:"",
        timer:null,
        ids: [],
        dateofIssue: ""
    };
  },
  watch: {
  },
  computed: {
    uploadZipFilePro(){
        return '/api/XOrg/ItcCertManager/uploadZipFilePro?dateofIssue='+this.dateofIssue;
    }
  },
  created() {
    // this.wordUrl = "/public/docs/"+this.excelName+".xlsx"
  },
  beforeDestroy() {
  },
  methods: {
    //导入
    importFile() {
        this.$refs.upload.submit();
    },
    // uploadZipFilePro(){
    //     // return '/api/XOrg/ItcCertManager/uploadZipFilePro';
    //     return `/api/XOrg/ItcCertManager/uploadZipFilePro`;
    //     // return '/api/XOrg/ItcCertManager/uploadZipFilePro?dateofIssue='+this.dateofIssue;
    // },
    // upload(param) {
    //     const formData = new FormData()
    //     formData.append('file', param.file)
    //     // const url = 'http://localhost:8888/uploadWithoutAction'
    //     // axios.post(url, formData).then(data => {
    //     //     console.log('上传图片成功')
    //     // }).catch(response => {
    //     //     console.log('图片上传失败')
    //     // })
    //     that.$http
    //     .post('/api/XOrg/ItcCertManager/uploadZipFilePro', formData, {
    //         dateofIssue: that.dateofIssue
    //     })
    //     .then(function () {
    //         that.percentageVisible = false;
    //         clearInterval(that.timer);
    //     })
    // },

    onSuccessUrl(res){
        var that = this;
        if (res.code > 0) {
            // this.ImportDialogVisible = false;
            this.percentageVisible = true;
            this.taskId = res.taskId;
            this.timer = setInterval(function(){
                that.$http
                .post('/api/XOrg/ImportTask/getImportProgress', {
                    id: res.taskId,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.percentage = rst.info.progressBar;
                        if(that.percentage == 100){

                            that.fileName1 = res.fileName;
                            that.loading1 = false;
                            that.uploadResultTip(res);

                            clearInterval(that.timer);
                            that.failExcel = rst.info.failExcel;
                            that.failNum = rst.info.failNumber;
                            that.successNum = rst.info.successNumber;
                            that.count = rst.info.importCount;
                            that.dataResultVisible = true;
                            that.percentageVisible = false;
                            that.percentage = 0;
                            that.page = 1;
                            that.$emit("refresh");
                        }
                    } else {
                        that.$message.warning(rst.msg);
                        clearInterval(that.timer);
                    }
                })
            }, 2000);
        }else {
            clearInterval(that.timer);
            this.$message.warning(res.msg);
        }
    },
    onErrorUrl(res){
        debugger;
        this.$message.error(res);
        // this.loading1 = false;
    },
    // 取消进度条
    cancelImport(){
        var that= this;
        that.$http
        .post('/api/XOrg/ImportTask/cancelImport', {
            id: that.taskId,
        })
        .then(function () {
            that.percentageVisible = false;
            clearInterval(that.timer);
        })
    },


    uploadUrl() {
        return `/api/XOrg/ItcCertManager/uploadZipFile?dateofIssue=${this.dateofIssue}`;
    },
    startUpload1() {

        if(this.dateofIssue){

        }else{
            this.$message.error("请选择发证时间!");
            return false;
        }

        // this.loading1 = true;
    },
    startUpload2() {
        this.loading2 = true;
    },
    startUpload3() {
        this.loading3 = true;
    },
    startUpload4() {
        this.loading4 = true;
    },
    startUpload5() {
        this.loading5 = true;
    },
    startUpload6() {
        this.loading6 = true;
    },
    startUpload7() {
        this.loading7 = true;
    },
    startUpload8() {
        this.loading8 = true;
    },
    startUpload9() {
        this.loading9 = true;
    },
    startUpload10() {
        this.loading10 = true;
    },
    startUpload11() {
        this.loading11 = true;
    },
    startUpload12() {
        this.loading12 = true;
    },



    onSuccessUrl1(res) {
        this.fileName1 = res.fileName;
        this.loading1 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl2(res) {
        this.fileName2 = res.fileName;
        this.loading2 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl3(res) {
        this.fileName3 = res.fileName;
        this.loading3 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl4(res) {
        this.fileName4 = res.fileName;
        this.loading4 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl5(res) {
        this.fileName5 = res.fileName;
        this.loading5 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl6(res) {
        this.fileName6 = res.fileName;
        this.loading6 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl7(res) {
        this.fileName7 = res.fileName;
        this.loading7 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl8(res) {
        this.fileName8 = res.fileName;
        this.loading8 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl9(res) {
        this.fileName9 = res.fileName;
        this.loading9 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl10(res) {
        this.fileName10 = res.fileName;
        this.loading10 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl11(res) {
        this.fileName11 = res.fileName;
        this.loading11 = false;
        this.uploadResultTip(res);
    },
    onSuccessUrl12(res) {
        this.fileName12 = res.fileName;
        this.loading12 = false;
        this.uploadResultTip(res);
    },

    uploadResultTip({
        code,
        msg
    }) {
        var that = this;
        if (code > 0) {
            that.$emit("refresh");
            this.$message.success(msg);
        } else {
            this.$message.error(msg);
        }
    },
  }
};
</script>
<style lang="scss">
.signup-importPhoto {
    padding: 6px 5px;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    display: inline-block;
}
.stu-zj-photos-con {
    border-radius: 8px;
    padding: 20px;
    background: #fff;
}

.upload-stu-photos-con {
    margin: 20px auto;
    width: 780px;

    .h3-title-val {
        margin-bottom: 35px;
        padding: 10px;
        color: #333;
        font-size: 20px;
        border-bottom: 1px solid #cccccc;

        span {
            padding-left: 10px;
            border-left: 4px solid #517efd;
        }
    }

    .step-upload-item {
        margin: 30px 0;

        .el-upload--picture-card {
            line-height: 1;
        }

        .upload-text-con {
            padding-top: 46px;
            color: #517efd;

            i {
                color: #517efd;
            }
        }

        .p-upload-tip-con {
            margin: 0 0 0 30px;

            p {
                margin-top: 4px;
                //color: #f56c6c;
            }
            .red{
                color: #f56c6c;
            }
            .suojin{
                text-indent: 2em;
            }
        
        }

        .else-upload-noNeed-tip {
            p {
                color: #333;
            }
        }
    }

    .p-file-name {
        margin-top: 10px;
        font-size: 16px;
        color: #517EFD;
        font-weight: bold;

        i {
            margin-left: 10px;
            color: #67C23A;
            font-size: 20px;
            vertical-align: -2px;
        }
    }
}





</style>
